import { useEffect, useRef, useCallback } from 'react';

export const useIdleLogout = ({ timeout = 5 * 60 * 1000, onIdle, isAuthenticated }) => {
  const timerRef = useRef(null);
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (isAuthenticated) timerRef.current = setTimeout(() => onIdleRef.current(), timeout);
  }, [isAuthenticated, timeout]);

  useEffect(() => {
    if (!isAuthenticated) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }

    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    const handleActivity = () => resetTimer();

    resetTimer();
    events.forEach(e => window.addEventListener(e, handleActivity));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, handleActivity));
    };
  }, [isAuthenticated, resetTimer]);
};
